import React from 'react';

function RadioOptions({ options, value, onChange }) {
  return (
    <>
      {options.map((option) => {
        const selected = value === option.code;
        return (
          <label
            key={option.code}
            className={`option-item${selected ? ' option-item--selected' : ''}`}
          >
            <span className="option-item__radio">
              <input
                type="radio"
                name="single-choice"
                value={option.code}
                checked={selected}
                onChange={(e) => onChange(e.target.value)}
              />
              <span className="option-item__radio-mark" />
            </span>
            <span className="option-item__label">{option.label}</span>
          </label>
        );
      })}
    </>
  );
}

export default RadioOptions;
